var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.$route.path === '/mapview')?_c('MapToolbar'):_c('Toolbar',{ref:"defaultToolbar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }